<template>
  <mobialisCard>
    <div class="row">
      <div class="flex-column pl-3">
        <div class="credit-card-success-icon-wrapper img">
          <inline-svg class="credit-card-success-icon" :src="require('@/assets/ic-credit-check.svg')" />
        </div>
      </div>
      <div class="col">
        <h2 data-cy="heading" class="my-2 heading">
          {{ heading }}
        </h2>
        <p class="mb-4 mt-2" data-cy="bodyCopy">{{ bodyCopy }}</p>
        <MobialisButton
          data-cy="applyNow"
          @click="btnClick"
          width="w-auto"
          v-av-analytics-cta-interaction="{ elementText: btnText, eventActionResult: 'open' }"
        >
          {{ btnText }}
        </MobialisButton>
        <p class="mb-2 mt-2">{{ $t('message.trade.nextSteps.disclaimer') }}</p>
      </div>
    </div>
  </mobialisCard>
</template>

<script>
import { mapGetters } from 'vuex';
import { CreditDataSourceCA } from '@/utils/enums';

export default {
  name: 'NextStep',
  data() {
    return {};
  },
  computed: {
    ...mapGetters('business', ['getDefaultCreditDataSourceCA', 'isPrequalificationEnabled', 'isKijijiDealer']),
    ...mapGetters(['getProductHomeRoute']),
    ...mapGetters('trade', ['getHasTradeInValuation']),
    equifaxEnabled() {
      return this.getDefaultCreditDataSourceCA === CreditDataSourceCA.EQUIFAX;
    },
    heading() {
      return this.equifaxEnabled
        ? this.$t('message.trade.nextSteps.heading.equifaxEnabled')
        : this.$t('message.trade.nextSteps.heading.default');
    },
    bodyCopy() {
      if (this.equifaxEnabled && this.isPrequalificationEnabled) {
        return this.$t('message.trade.nextSteps.nextText.equifaxAndPrequalEnabled');
      }
      switch (true) {
        case this.getHasTradeInValuation === true:
          if (this.equifaxEnabled) {
            return this.$t('message.trade.nextSteps.nextText.equifaxEnabled');
          }
          return this.$t('message.trade.nextSteps.nextText.default');
        default:
          if (this.equifaxEnabled) {
            return this.$t('message.trade.nextSteps.nextText.noTradeInValuation.equifaxEnabled');
          }
          return this.$t('message.trade.nextSteps.nextText.noTradeInValuation.default');
      }
    },
    btnText() {
      if (this.isPrequalificationEnabled) {
        return this.$t('message.trade.nextSteps.btnText.prequalEnabled');
      }
      if (this.equifaxEnabled) {
        return this.$t('message.trade.nextSteps.btnText.equifaxEnabled');
      }
      return this.$t('message.trade.nextSteps.btnText.default');
    },
  },
  methods: {
    btnClick() {
      this.$router.push({ path: this.getProductHomeRoute('credit') });
    },
  },
};
</script>

<style lang="scss" scoped>
h2.heading {
  font-size: 20px;
  font-weight: bold;
  line-height: 25px;
  @media (max-width: $breakpoint-mobile) {
    font-size: 18px;
    line-height: 22.5px;
  }
}
p {
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #4b5863;
}
</style>
